import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import ListBase from "../../../pages/list/ListBase";
import DrawerBase from "../drawer/DrawerBase";
import { lists } from "../../../utils/list";

interface IModalViewComment {
  post: any;
}

function ModalViewComment({ post }: IModalViewComment) {
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* {open && (
        <ModalBase
          title={`Bình luận bài viết`}
          open={open}
          handleClose={handleClose}
          width="500px"
        >
          <Stack sx={{ height: "auto", maxHeight: "80vh", overflow: "auto" }}>
            {isArray(comments) && comments?.length > 0 ? (
              <Stack gap={1} sx={{px: 2 }}>
                {comments.map(comment => {
                  return (
                    <Comment key={comment._id} data={comment} />
                  )
                })}
              </Stack>
            ) : (
              <Typography
                sx={{ textAlign: "center", fontStyle: "italic", py: 2 }}
              >
                Chưa có bình luận
              </Typography>
            )}
          </Stack>
        </ModalBase>
      )} */}
      <DrawerBase open={open} onClose={handleClose} anchor="bottom">
        <Box
          sx={{
            height: `90vh`,
            overflow: "auto",
            px: 1,
            backgroundColor: "background.default",
          }}
        >
          {open && (
            <ListBase
              category={{
                ...lists.socialcomment,
                condition: { postId: post?._id },
                title: `Bình luận bài viết của '${post?.name_user_created}'`,
              }}
              filterSx={{ height: "calc(90vh - 16px)" }}
              tableSx={{ height: "calc(90vh - 50px - 42px - 16px)" }}
              fixedHeaderScrollHeight="calc(90vh - 16px - 42px - 50px)"
            />
          )}
        </Box>
      </DrawerBase>
      <Button
        onClick={() => setOpen(true)}
        size="small"
        variant="contained"
        color="secondary"
        sx={{
          textTransform: "none",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        }}
      >
        Xem
      </Button>
    </>
  );
}

export default ModalViewComment;
